import React, { Fragment, Component } from "react";
import { translate } from "react-i18next";
import transferConfirmation from "../../img/last-operations-icon.png";
import Loading from "./../../Loading/Loading";
import { request } from "./../../../../config";
import DatePickerInput from "./DatePickerInput";
import AddCarModal from "./AddCarModal";
import YesNoModal from "./../../../../copms/Modal/YesNoModal";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

class MyCars extends Component {
  state = {
    isLoading: false,
    cars: [],
    selectedCarId: null,
    selectedCarDetails: {
      id: null,
      carNumber: "",
      finCode: "",
      birthDate: "",
      note: "",
      fineNotification: true,
      parkingNotification: true,
      // carStatus: null,
    },
    payments: [],
    deleteOpen: false,
    addModalOpen: false,
  };

  updateBirthDate = (dateValue) => {
    if (dateValue) {
      let formatedDate = {
        day:
          dateValue.getDate() < 9
            ? "0" + dateValue.getDate()
            : dateValue.getDate(),
        month:
          dateValue.getMonth() < 9
            ? "0" + (dateValue.getMonth() + 1)
            : dateValue.getMonth() + 1,
        year: dateValue.getFullYear().toString(),
      };
      // return formatedDate.day + '-' + formatedDate.month + '-' + formatedDate.year;
      const date =
        formatedDate.year + "-" + formatedDate.month + "-" + formatedDate.day;
      this.setState({
        selectedCarDetails: {
          ...this.state.selectedCarDetails,
          birthDate: date,
        },
      });
    }
  };
  getFormatedDate(dateStr) {
    if (dateStr) {
      const parts = dateStr.split(".");
      if (parts.length === 3) {
        const [day, month, year] = parts;
        return `${day}/${month}/${year}`;
      }

      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return null;

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return null;
  }

  getAllCars = () => {
    this.setState({ isLoading: true });
    fetch(request("car/getCarsByCustomer", {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
    }))
      .then((res) => res.text())
      .then((json) => {
        const JSON = require("true-json-bigint");
        const res = JSON.parse(json);
        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) this.props.logout();
          else this.setState({ isLoading: false });
        } else {
          const cars = res.allCarList || [];
          this.setState(
            { isLoading: false, cars, selectedCarId: cars.length ? cars[0].id : null },
            () => { if (cars.length) this.getCarById(); }
          );
        }
      })
      .catch(() => this.props.history.push("/technical-break"));
  };

  getCarById = () => {
    this.setState({ isLoading: true });
    fetch(request("car/getByFilters", {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      id: this.state.selectedCarId,
    }))
      .then((res) => res.text())
      .then((json) => {
        const JSON = require("true-json-bigint");
        const res = JSON.parse(json);
        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) this.props.logout();
          else {
            this.props.alertState(true, "error", this.props.t("an error occurred"), this.props.t(res.status.statusCode));
            this.setState({ isLoading: false });
          }
        } else {
          this.setState({
            isLoading: false,
            selectedCarDetails: {
              id: res.id,
              carNumber: res.carNumber,
              finCode: res.finCode,
              birthDate: res.birthDate,
              note: res.note,
              fineNotification: res.fineNotification,
              parkingNotification: res.parkingNotification,
              carStatus: res.carStatus,
            },
          },
          this.getAllPenaltyPayments,
        );
        }
      })
      .catch(() => this.props.history.push("/technical-break"));
  };

  handleEditCar = (e, editedPart) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    fetch(request("car/updateCar", {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      id: this.state.selectedCarId,
      ...editedPart,
    }))
      .then((res) => res.text())
      .then((json) => {
        const JSON = require("true-json-bigint");
        const res = JSON.parse(json);
        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) this.props.logout();
          else {
            this.props.alertState(true, "error", this.props.t("an error occurred"), this.props.t(res.status.statusCode));
            this.setState({ isLoading: false });
          }
        } else {
          this.props.alertState(true, "success", this.props.t("successful operation"), this.props.t("information changed successfully"), null, null, this.getAllCars);
          this.setState({ isLoading: false });
        }
      })
      .catch(() => this.props.history.push("/technical-break"));
  };

  getAllPenaltyPayments = () => {
    this.setState({ isLoading: true });
    fetch(request("car/findPenaltyPaymentList", {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      finCode: this.state.selectedCarDetails.finCode,
      carNumber: this.state.selectedCarDetails.carNumber,
    }))
      .then((res) => res.text())
      .then((json) => {
        const JSON = require("true-json-bigint");
        const res = JSON.parse(json);
        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) this.props.logout();
          else {
            this.props.alertState(true, "error", this.props.t("an error occurred"), this.props.t(res.status.statusCode));
            this.setState({ isLoading: false });
          }
        } else {
          this.setState({ payments: res.penaltyInfo, isLoading: false });
        }
      })
      .catch(() => this.props.history.push("/technical-break"));
  };

  deleteConfirm = () => {
    this.setState({ isLoading: true });
    fetch(request("car/deleteCar", {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      id: this.state.selectedCarId,
    }))
      .then((res) => res.text())
      .then((json) => {
        const JSON = require("true-json-bigint");
        const res = JSON.parse(json);
        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) this.props.logout();
          else {
            this.props.alertState(true, "error", this.props.t("an error occurred"), this.props.t(res.status.statusCode));
            this.setState({ isLoading: false });
          }
          return;
        }
        const deletedId = this.state.selectedCarId;
        this.setState(
          (prev) => ({
            deleteOpen: false,
            selectedCarId: null,
            cars: prev.cars.filter((car) => car.id !== deletedId),
            selectedCarDetails: {
              id: null,
              carNumber: "",
              finCode: "",
              birthDate: "",
              note: "",
              fineNotification: true,
              parkingNotification: true,
            },
            isLoading: false,
          }),
          () => {
            this.getAllCars();
          },
        );
      })
      .catch(() => this.props.history.push("/technical-break"));
  };

  componentDidMount() {
    this.getAllCars();
  }

  renderCarDetailSections() {
    const { selectedCarId, selectedCarDetails, payments } = this.state;
    const { t } = this.props;
    if (!selectedCarId) return null;

    return (
      <>
        {/* Car details */}
        <div className="dashboard-payment-parking-right-container-section">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <p className="dashboard-payment-parking-right-container-section-title">{t("Car details")}</p>
            <button style={{ display: "flex", alignItems: "center", gap: "0.5rem" }} onClick={() => this.setState({ deleteOpen: true })}>
              <DeleteOutlinedIcon style={{ color: "#DC2626" }} />
              <p style={{ color: "#DC2626" }}>{t("Delete car")}</p>
            </button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
            <div
              className="dashboard-payment-container-data-section-content-container-form-container"
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem" }}
            >
              {/* Car number */}
              <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                <label style={{ color: "#364153" }} className="dashboard-payment-container-data-section-content-container-form-label">
                  {t("car number")}
                </label>
                <div className="dashboard-payment-container-data-section-content-container-form-input-box">
                  <input
                    type="text"
                    className="dashboard-payment-container-data-section-content-container-form-input"
                    value={selectedCarDetails.carNumber}
                    placeholder="AA 000 AZ"
                    onChange={(e) => this.setState({ selectedCarDetails: { ...selectedCarDetails, carNumber: e.target.value } })}
                    maxLength="10"
                  />
                </div>
              </div>

              {/* Pin code */}
              <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                <label style={{ color: "#364153" }} className="dashboard-payment-container-data-section-content-container-form-label">
                  {t("Pin code")}
                </label>
                <div className="dashboard-payment-container-data-section-content-container-form-input-box">
                  <input
                    type="text"
                    className="dashboard-payment-container-data-section-content-container-form-input"
                    value={selectedCarDetails.finCode}
                    placeholder="12345678"
                    onChange={(e) => this.setState({ selectedCarDetails: { ...selectedCarDetails, finCode: e.target.value } })}
                    maxLength="8"
                  />
                </div>
                <p className="dashboard-payment-parking-right-container-info">
                  <InfoOutlinedIcon fontSize="small" />
                  {t("fin_code_info")}
                </p>
              </div>

              {/* Date of birth */}
              <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                <label style={{ color: "#364153" }} className="dashboard-payment-container-data-section-content-container-form-label">
                  {t("Date of birth")}
                </label>
                <div className="dashboard-payment-container-data-section-content-container-form-input-box">
                  <DatePickerInput
                    value={
                      selectedCarDetails.birthDate
                        ? selectedCarDetails.birthDate instanceof Date
                          ? selectedCarDetails.birthDate
                          : this.getFormatedDate(selectedCarDetails.birthDate) // only format API strings
                        : null
                    }
                    updateDate={this.updateBirthDate}
                  />
                </div>
              </div>

              {/* Note */}
              <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                <label style={{ color: "#364153" }} className="dashboard-payment-container-data-section-content-container-form-label">
                  {t("note")}
                </label>
                <div className="dashboard-payment-container-data-section-content-container-form-input-box">
                  <input
                    type="text"
                    className="dashboard-payment-container-data-section-content-container-form-input"
                    value={selectedCarDetails.note}
                    placeholder={t("add note")}
                    onChange={(e) => this.setState({ selectedCarDetails: { ...selectedCarDetails, note: e.target.value } })}
                  />
                </div>
              </div>
            </div>
            <div style={{ textAlign: "end" }}>
              <button className="dashboard-header-route-button" onClick={(e) => this.handleEditCar(e, selectedCarDetails)}>
                {t("Update")}
              </button>
            </div>
          </div>
        </div>

        {/* Notifications */}
        <div className="dashboard-payment-parking-right-container-section">
          <p className="dashboard-payment-parking-right-container-section-title">{t("notifications")}</p>
          <div style={{ marginTop: "1.5rem" }} className="dashboard-payment-parking-right-container-notifications">
            <div className="dashboard-payment-parking-right-container-notification">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="dashboard-payment-parking-right-container-notification-title">{t("fine notices")}</p>
                <p className="dashboard-payment-parking-right-container-notification-description">{t("Fine notices description")}</p>
              </div>
              <div
                className={`dashboard-payment-parking-right-container-notification-switch ${selectedCarDetails.fineNotification ? "checked" : ""}`}
                onClick={(e) => this.setState(
                  { selectedCarDetails: { ...selectedCarDetails, fineNotification: !selectedCarDetails.fineNotification } },
                  this.handleEditCar(e, { fineNotification: !selectedCarDetails.fineNotification })
                )}
              >
                <div className="dashboard-payment-parking-right-container-notification-switch-track">
                  <div className="dashboard-payment-parking-right-container-notification-switch-thumb"></div>
                </div>
              </div>
            </div>
            <div className="dashboard-payment-parking-right-container-notification">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="dashboard-payment-parking-right-container-notification-title">{t("parking notices")}</p>
                <p className="dashboard-payment-parking-right-container-notification-description">{t("Parking notices description")}</p>
              </div>
              <div
                className={`dashboard-payment-parking-right-container-notification-switch ${selectedCarDetails.parkingNotification ? "checked" : ""}`}
                onClick={(e) => this.setState(
                  { selectedCarDetails: { ...selectedCarDetails, parkingNotification: !selectedCarDetails.parkingNotification } },
                  this.handleEditCar(e, { parkingNotification: !selectedCarDetails.parkingNotification })
                )}
              >
                <div className="dashboard-payment-parking-right-container-notification-switch-track">
                  <div className="dashboard-payment-parking-right-container-notification-switch-thumb"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Payments */}
        <div className="dashboard-payment-parking-right-container-section">
          <p className="dashboard-payment-parking-right-container-section-title">{t("payments")}</p>
          {payments.length > 0 && (
            <table className="dashboard-transfer-list-table">
              <tbody className="dashboard-transfer-list-table-body">
                {payments.map((payment, index) => (
                  <tr
                    key={index}
                    className="dashboard-transfer-list-table-row"
                    onClick={() => this.props.history.push(`/dashboard/payment/payments/categories/${payment.categoryId}/providers/${payment.merchantId}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="dashboard-finance-section-cards-section-cell">
                      <div className="dashboard-finance-section-cards-section-cell-icon dashboard-finance-section-cards-section-cell-icon__circle">
                        <img src={payment.url} className="dashboard-finance-section-cards-section-cell-icon__circle-img" />
                      </div>
                      <div className="dashboard-finance-section-cards-section-cell-main-section">
                        <span className="dashboard-finance-section-cards-section-cell-content">{payment.merchantName}</span>
                        <span className="dashboard-finance-section-cards-section-cell-title">{payment.billingDate}, </span>
                      </div>
                    </td>
                    <td className="dashboard-finance-section-cards-section-cell dashboard-finance-section-cards-section-cell__right">
                      <p className="dashboard-finance-section-cards-section-cell-content">
                        <span className="dashboard-payment-operation-section-content-item-amount-whole-part">{payment.amount}</span>
                        <span className="dashboard-payment-operation-section-content-item-amount-currency">{payment.amtCcy}</span>
                      </p>
                        <p
                          className="dashboard-finance-section-cards-section-cell-title"
                          style={{fontWeight: 500, color: payment.color}}
                        >
                          {payment.payStatus}
                        </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </>
    );
  }

  render() {
    const {
      isLoading,
      cars,
      selectedCarId,
      selectedCarDetails,
      deleteOpen,
      addModalOpen,
    } = this.state;
    const { t } = this.props;

    return (
      <Fragment>
        <YesNoModal
          onClose={() => this.setState({ deleteOpen: false })}
          title={t("Are you sure you want to delete this car?")}
          body={t("delete car body", {
            carNumber: selectedCarDetails.carNumber,
          })}
          open={deleteOpen}
          triggerFunc={this.deleteConfirm}
        />
        <AddCarModal
          open={addModalOpen}
          onClose={() => this.setState({ addModalOpen: false })}
          onSuccess={this.getAllCars}
          alertState={this.props.alertState}
          t={t}
        />

        <div className="dashboard-header-route">
          <div className="dashboard-header-route-left">
            <button onClick={() => this.props.history.goBack()}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z"
                  fill="#2E3131"
                />
              </svg>
            </button>
            <h2>{t("my cars")}</h2>
          </div>
        </div>

        {isLoading ? (
          <div className="dashboard-container-main-section">
            <Loading />
          </div>
        ) : (
          <div className="dashboard-payment-container">
            <div className="dashboard-payment-container-data-section">
              {cars.length > 0 && (
                <h6 style={{ margin: "1.5rem 2rem 0rem 2rem" }}>
                  {t("Added cars")}
                </h6>
              )}

              <div className="dashboard-payment-parking-layout">
                {/* ===== LEFT COLUMN ===== */}
                <div className="dashboard-payment-parking-left-container">
                  {cars.length > 0 && (
                    <div className="dashboard-payment-parking-left-container-cars">
                      {cars.map((car) => {
                        const isSelected = selectedCarId === car.id;
                        return (
                          <React.Fragment key={car.id}>
                            <button
                              onClick={() =>
                                this.setState(
                                  { selectedCarId: car.id },
                                  this.getCarById,
                                )
                              }
                              className={`dashboard-payment-parking-left-container-car ${isSelected ? "active" : ""}`}
                            >
                              <div className="dashboard-payment-parking-left-container-car-header">
                                <p className="dashboard-payment-parking-left-container-car-number">
                                  {car.carNumber}
                                </p>
                                <div className="dashboard-payment-parking-left-container-car-radio">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                  >
                                    <circle
                                      cx="10"
                                      cy="10"
                                      r="9"
                                      stroke="#007BFF"
                                      strokeWidth="2"
                                      fill="none"
                                    />
                                    {isSelected && (
                                      <>
                                        <circle
                                          cx="10"
                                          cy="10"
                                          r="8"
                                          fill="#007BFF"
                                        />
                                        <path
                                          d="M6 10L9 13L14 7"
                                          stroke="white"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </>
                                    )}
                                  </svg>
                                </div>
                              </div>
                              <p className="dashboard-payment-parking-left-container-car-note">
                                {car.note}
                              </p>
                              <div className="dashboard-payment-parking-left-container-car-info-line">
                                <p className="dashboard-payment-parking-left-container-car-info-key">
                                  {t("Pin code")}
                                </p>
                                <p className="dashboard-payment-parking-left-container-car-info-value">
                                  {car.finCode}
                                </p>
                              </div>
                              <div className="dashboard-payment-parking-left-container-car-info-line">
                                <p className="dashboard-payment-parking-left-container-car-info-key">
                                  {t("Date of birth")}
                                </p>
                                <p className="dashboard-payment-parking-left-container-car-info-value">
                                  {car.birthDate}
                                </p>
                              </div>
                            </button>

                            {/*
                              MOBILE ONLY: render detail sections inline,
                              directly after the selected car card.
                              Hidden on desktop via CSS.
                            */}
                            {isSelected && (
                              <div className="dashboard-payment-parking-inline-details">
                                {this.renderCarDetailSections()}
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  )}

                  <button
                    className="dashboard-payment-parking-add-car-btn"
                    onClick={() => this.setState({ addModalOpen: true })}
                  >
                    + {t("Add car")}
                  </button>
                </div>

                {/* ===== RIGHT COLUMN (desktop only) ===== */}
                <div className="dashboard-payment-parking-right-container">
                  {this.renderCarDetailSections()}
                </div>
              </div>
            </div>

            {/* ===== Sidebar info panel ===== */}
            <div className="dashboard-payment-container-confirmation-section">
              {/* <div className="dashboard-payment-container-confirmation-section-header">
                <h3 className="dashboard-payment-container-confirmation-section-header-title">
                  {t("How to make bulk transfers?")}
                </h3>
              </div> */}
              <div className="dashboard-payment-container-confirmation-section-content">
                <img
                  src={transferConfirmation}
                  className="dashboard-payment-container-confirmation-section-content-image"
                  alt="confirmation-content-image"
                />
                <div className="dashboard-payment-container-confirmation-section-content-description">
                  <p>{t("my cars section definition")}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default translate("translation")(MyCars);
